export const lightBlue = '#E7F0FE';
export const lightOrange = '#ffede6';
export const lightRed = '#fff6f2';
export const lightYellow = '#fffaec';
export const peach = '#ffb799';
export const mediumOrange = '#FF9266';
